import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import VxRadioField from '../vxFields/VxRadioField';
import AddRemovePrograms from './AddRemovePrograms';
import { BTN_FACTORY_FORM } from '../../clientConstants';
import getLocaleMessages from '../../utils/localesMessages';
import _get from 'lodash/get';
import TooltipTarget from '../tooltip/TooltipTarget';

const {
	chooseSpecificPrograms,
	noListPrograms,
	yesListPrograms,
	tooltip = {}
} = getLocaleMessages('buttons/wizardStepTwo');

const mapStateToProps = (state) => {
	const formValues = getFormValues(BTN_FACTORY_FORM)(state) || {};

	return {
		formValues
	}
}

class Programs extends Component {
	static propTypes = {
		formValues: PropTypes.object,
		addProgram: PropTypes.func,
		removeProgram: PropTypes.func
	}

	renderChooseSpecificPrograms = (props) => {
		return (
			<VxRadioField
				{...props}
			/>
		)
	}
	
	render() {
		const listPrograms = _get(this.props, 'formValues.listPrograms', 'no');

		return (
			<div className="programs-container">
				<div className="help-text">{chooseSpecificPrograms}
					<TooltipTarget content={tooltip.program}
						id="tooltip-program"
						placement="top">
					</TooltipTarget>
				</div>

				<Field
					type="radio"
					id="doNotListPrograms"
					name="listPrograms"
					value="no"
					checkedValue={listPrograms}
					component={this.renderChooseSpecificPrograms}
					label={noListPrograms}
				/>
				<Field
					type="radio"
					id="listPrograms"
					name="listPrograms"
					value="yes"
					checkedValue={listPrograms}
					component={this.renderChooseSpecificPrograms}
					label={yesListPrograms}
				/>
				{listPrograms === 'yes' &&
					<div className="button-style-elements fields-margin-left">
						<AddRemovePrograms
							addProgram={this.props.addProgram}
							removeProgram={this.props.removeProgram}
						/>
					</div>
				}
			</div>
		);
	}
}

export default connect(mapStateToProps)(Programs);



// WEBPACK FOOTER //
// ./buttons/components/programs/Programs.js